import { IModel } from '../interfaces/Core.js';

/**
 * ABaseModel
 */
abstract class ABaseModel implements IModel {
  /**
   * filterProperty
   *
   * @param {string} property
   * @param {any} value
   * @returns {boolean} if true then the property will be excluded from model
   */
  // eslint-disable-next-line
  protected filterProperty(property: string, value?: any): boolean {
    return false;
  }

  /**
   * describeProperties
   * TODO: Black List: Method should accept a blacklist of properties that will be excluded
   *
   * @returns {string}
   */
  public describeProperties(): string {
    return Object.keys(this).reduce((accumulator, key) => `${accumulator}  ${key}`);
  }

  /**
   * generateId
   *
   * @returns {string}
   */
  public static generateId(parameters: unknown): string {
    return Buffer.from(JSON.stringify(parameters), 'utf8').toString('base64');
  }

  /**
   * hydrate
   *
   * @returns {this}
   */
  public hydrate(parameters = null, generateId = false): this {
    if (!parameters) {
      throw new Error('Parameters are required to hydrate the model');
    }
    if (!parameters.id && generateId === true) {
      parameters['id'] = ABaseModel.generateId(parameters);
    }

    Object.keys(parameters).forEach((propertyKey) => {
      // TODO: Find a way to check if properties are defined
      // in children (extending) models, is it possible in TS/JS?
      if (typeof this.filterProperty !== 'function' || !this.filterProperty(propertyKey, parameters[propertyKey])) {
        this[propertyKey] = parameters[propertyKey];
      }
    });

    return this;
  }

  /**
   * toJson
   *
   * @returns {string}
   */
  public toJson(): string {
    return JSON.stringify(this);
  }
}

export { ABaseModel };
